import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { StatisticsContainerComponent } from "./statistics-container/statistics-container.component";
import { StatisticsPanelComponent } from "./statistics-panel.component";
import { ControlsComponentsModule } from "@karma-games/angular-devkit/src/lib/modules/controls-components";
import { PipesModule } from "@karma-games/angular-devkit/src/lib/modules/pipes";
import { StatisticsListItemComponent } from "./statistics-list-item/statistics-list-item.component";
import { SharedComponentsModule } from "@karma-games/angular-devkit/src/lib/modules/shared-components";
import { ClientSharedComponentsModule } from "../shared/components/client-shared-components.module";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { StatisticsRepository } from "./statistics.repository";
import { StatisticsState } from "./store/interfaces";
import { statisticsReducer } from "./store/statistics.reducers";
import { StoreModule } from "@karma-games/angular-devkit/src/lib/extended-store";
import "./store/statistics.extensions";

@NgModule({
    declarations: [
        StatisticsContainerComponent,
        StatisticsPanelComponent,
        StatisticsListItemComponent
    ],
    providers: [
        StatisticsRepository
    ],
    imports: [
        CommonModule,
        ControlsComponentsModule,
        PipesModule,
        SharedComponentsModule,
        ClientSharedComponentsModule,
        ScrollingModule,
        StoreModule.forFeature(StatisticsState.featureKey, statisticsReducer)
    ],
    exports: [StatisticsPanelComponent]
})
export class StatisticsPanelModule {
}
